import { render, staticRenderFns } from "./BreaksClassroomPlaceholder.vue?vue&type=template&id=694068bc&"
import script from "./BreaksClassroomPlaceholder.vue?vue&type=script&setup=true&lang=js&"
export * from "./BreaksClassroomPlaceholder.vue?vue&type=script&setup=true&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports